/* eslint-disable sort-imports */
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';

var opts = Object.prototype.toString;

function isObject(value) {
    return opts.call(value) === '[object Object]';
}

function formatModel(modelData) {
    Object.keys(modelData).forEach(function(key) {
        var value = modelData[key];

        if (isObject(value)) {
            modelData[key] = formatModel(value);
            return;
        }

        if (typeof value === 'number') {
            modelData[key] = '$' + value.toFixed(2);
        }
    });

    return modelData;
}

function formatDiscounts(discounts) {
    return !discounts
        ? []
        : Object.keys(discounts).map(function(key) {
                return {
                    name: key,
                    value: discounts[key]
                };
            });
}

function CostSummaryViewModel(modelData) {
    ko.mapping.fromJS(formatModel(modelData), {}, this);

    this.Discounts = ko.observable(ko.toJS(this.Discounts));
    this.OrderDiscounts = ko.observable(ko.toJS(this.OrderDiscounts));
    this.orderDiscounts = ko.observableArray(formatDiscounts(this.OrderDiscounts()));
    this.discounts = ko.observableArray(formatDiscounts(this.Discounts()));
    this.itemsDiscounts = ko.computed(
        function() {
            return formatDiscounts(itemLevelDiscounts(this.Discounts(), this.OrderDiscounts()));
        }.bind(this)
    );
    
    this.orderTotal = ko.observable(absolutePrice(this.OrderTotal()));

    this.hasFreeShipping = ko.observable(this.IsFreeShipping());

    this.processingFeeEnabled = smartPak.pageData && smartPak.pageData.processingFeeEnabled;

    this.itemsDiscountMessage = ko.computed(
        function() {
            return this.itemsDiscounts()
                .map(function(discount) {
                    return discount.name;
                })
                .join(', ');
        }.bind(this)
    );

    this.itemsDiscountSum = ko.computed(
        function() {
            return '$' + (dollarToNumber(this.DiscountSum()) - dollarToNumber(this.OrderDiscountSum())).toFixed(2);
        }.bind(this)
    );

    this.discountMessage = ko.computed(
        function() {
            return this.discounts()
                .map(function(discount) {
                    return discount.name;
                })
                .join(', ');
        }.bind(this)
    );

    this.hasSavings = ko.computed(
        function() {
            return this.DiscountSum() !== '$0.00';
        }.bind(this)
    );

    this.hasCredits = ko.computed(() => {
        var credits = this.Credits();
        return credits && credits !== '$0.00';
    });

    this.hasGiftCertificates = ko.computed(() => {
        var giftCertificates = this.GiftCertificatesAmount();
        return giftCertificates && giftCertificates !== '$0.00';
    });

    this.hasProcessingFees = ko.computed(() => {
        var fees = this.ProcessingFee();
        return fees && fees !== '$0.00';
    });
}

CostSummaryViewModel.prototype.update = function(modelData) {
    var model = formatModel(modelData),
        name;

    for (name in model) {
        if (typeof this[name] === 'function') {
            this[name](model[name]);

            if (name === 'OrderTotal') {
                this.orderTotal(absolutePrice(model[name]));
            }

            if (name === 'IsFreeShipping') {
                this.hasFreeShipping(model[name]);
            }

            if (name === 'OrderDiscounts') {
                this.orderDiscounts(formatDiscounts(model[name]));
            }

            if (name === 'Discounts') {
                this.discounts(formatDiscounts(model[name]));
            }
        } else {
            this[name] = model[name];
        }
    }
};

function absolutePrice(str) {
    return '$' + Math.abs(dollarToNumber(str)).toFixed(2);
}

function dollarToNumber(str) {
    return +str.substring(1);
}

function itemLevelDiscounts(allDiscounts, orderDiscounts) {
    return !allDiscounts
        ? {}
        : Object.keys(allDiscounts).reduce(function(itemDiscounts, key) {
                if (orderDiscounts && !orderDiscounts[key]) {
                    itemDiscounts[key] = allDiscounts[key];
                }

                return itemDiscounts;
            }, {});
}

export default CostSummaryViewModel;
